import { getFileMime } from '@/helpers';
import { ref } from 'vue';

export function useFileUploadForm(
  onFileAdded: (event: Event, files: UploadedFile[]) => void = undefined,
  onFileRemoved: (file: UploadedFile, index: number) => void = undefined,
) {
  const filesUploaded = ref<UploadedFile[]>([]);

  const addFile = async (event: Event, resetOnInput = false) => {
    const files = Array.from((event.target as HTMLInputElement).files);

    if(resetOnInput) {
      filesUploaded.value = [];
    }

    const filesProcessed = [];

    for(let index = 0;index < files.length;index++) {
      filesProcessed.push((async () => {
        const file = files[index];
        const mimeType = await getFileMime(file);

        filesUploaded.value.push({
          fileName: file.name,
          mime: mimeType,
          fileBlob: file,
        });
      })());
    }

    await Promise.all(filesProcessed);

    if(onFileAdded) {
      onFileAdded(event, filesUploaded.value);
    }
  };

  const removeFile = (index: number) => {
    const file = filesUploaded.value.splice(index, 1)[0];

    if(onFileRemoved) {
      onFileRemoved(file, index);
    }
  };

  return {
    addFile,
    removeFile,
    filesUploaded,
  };
}
